import React from 'react';

const Calculator = () => {
    return (
        <div>
            <p>This is the calculator</p>
        </div>
    );
};

export default React.memo(Calculator);